// ArriveInfoDict.js
// DbdbTap 2024-08-28 13:54:51
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";
import ValueMisc from "../../value/ValueMisc";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    arriveId : {
		id: 'arriveId', label: '출발도착코드',
		type: InputType.text, required: true, toAdd: false, toEdit: true,
	},
    dcCd : {
		id: 'dcCd', label: '출발지',
		type: InputType.select, required: true, toAdd: true, toEdit: false,
        labelKey: 'dcName', // from dc_info (in using VzmSelector)
        check: (value) => IsValid.dcCode(value),
	},
    storeId : {
		id: 'storeId', label: '도착지',
		type: InputType.text, required: true, toAdd: true, toEdit: false,
        labelKey: 'storeName', // from store_info
        getOptionLabel: (option) => option.storeName + ' (코드 ' + option.storeId + ')',
        check: (value) => IsValid.numericString(value, 3, 7),
	},
    basicDockno : {
		id: 'basicDockno', label: '기본상차도크번호',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999},
	},
    distanceOne : {
		id: 'distanceOne', label: '편도거리',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	},
    distanceRound : {
		id: 'distanceRound', label: '왕복거리',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	},
    basicExpectRunTime : {
		id: 'basicExpectRunTime', label: '기본예상운행시간',
		type: InputType.time, required: false, toAdd: true, toEdit: true,
		help: '4자 이내로 입력하세요.',
		check: (value) => {return !Boolean(value) || IsValid.hhmm4(value)},
	},
    startReqTimeToday : {
		id: 'startReqTimeToday', label: '출발요청시간',
		type: InputType.time, required: false, toAdd: true, toEdit: true,
		check: (value) => {return !Boolean(value) || IsValid.hhmm4(value)},
	},
    arriveReqTimeNext : {
		id: 'arriveReqTimeNext', label: '도착요청시간',
		type: InputType.time, required: false, toAdd: true, toEdit: true,
		check: (value) => {return !Boolean(value) || IsValid.hhmm4(value)},
	},
    regTypeCd : {
		id: 'regTypeCd', label: '등록구분',
		type: InputType.select, required: true, toAdd: true, toEdit: false,
        default: 'A',
	},
    firstShipTime : {
		id: 'firstShipTime', label: '첫차배송시간',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		check: (value) => {return !Boolean(value) || IsValid.hhmm4(value)},
	},
    lastShipTime : {
		id: 'lastShipTime', label: '막차배송시간',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		check: (value) => {return !Boolean(value) || IsValid.hhmm4(value)},
	},
    autoPlanYn : {
		id: 'autoPlanYn', label: '자동배차',
		type: InputType.checkbox, required: true, toAdd: true, toEdit: true,
		trueValue: 'Y', falseValue: 'N',
	},
    mainVehTypeId : {
		id: 'mainVehTypeId', label: '주력차종',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		labelKey: 'vehTypeName', valueKey: 'vehTypeId', // from veh_type_info
	},
    maxVehTypeId : {
		id: 'maxVehTypeId', label: '최대차종',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		labelKey: 'vehTypeName', valueKey: 'vehTypeId', // from veh_type_info
	},
    storeApplyCom : {
		id: 'storeApplyCom', label: '운송사',
		type: InputType.select, required: false, toAdd: true, toEdit: true,
		labelKey: 'comName', valueKey: 'comId', // from com_info
	},
    pbsOrder : {
		id: 'pbsOrder', label: 'PBS취급 우선순위',
		type: InputType.number, required: false, toAdd: false, toEdit: false,
		check: (value) => {return value >= -999 && value <= 999},
	},
    loadMaxCnt : {
		id: 'loadMaxCnt', label: '상차구역최대범위',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	},
    autoPlanOrder : {
		id: 'autoPlanOrder', label: '처리순서',
		type: InputType.number, required: false, toAdd: false, toEdit: false,
		check: (value) => {return value >= -999 && value <= 999},
	},
    autoViewOrder : {
		id: 'autoViewOrder', label: '표시순서',
		type: InputType.number, required: false, toAdd: false, toEdit: false,
		check: (value) => {return value >= -999 && value <= 999},
	},
    // dcTypeCd : { id: 'dcTypeCd', label: 'dcTypeCd', },
    dcTypeName : { id: 'dcTypeName', label: 'DC구분', },
    dcName : { id: 'dcName', label: '출발지', },
    storeTypeName : { id: 'storeTypeName', label: '점포타입', },
    //storeTypeCd : { id: 'storeTypeCd', label: 'storeTypeCd', },
    storeName : { id: 'storeName', label: '도착지' },
    mainVehTypeName : { id: 'mainVehTypeName', label: '주력차종', },
    maxVehTypeName : { id: 'maxVehTypeName', label: '최대차종', },
    comName : { id: 'comName', label: '운송사' },
    regType : { id: 'regType', label: '등록구분', },
    regUserName : { id: 'regUserName', label: '등록자', },
    
};

const DictUsage = {
    arriveId : {
		id: Dict.arriveId.id, label: '도착정보지정',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	},
    useYn : {
		id: 'useYn', label: 'useYn',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
	},
}

const AutoOrderTableProps = {
    tableId: 'arriveInfoAutoViewOrderTable',
    //inTableId: 'vehTypeGroupOrderInTable',
    //outTableId: 'vehTypeGroupOrderOutTable',
    uniqueKey: Dict.arriveId.id,
    flexOption: {
        multiChecker:false,
        hideFirstTopButton: false,
        hideColumnConfig: true,
        growToFill: true,
        noSorting: true,
        hideBubble: true,
    },
};
/**
 * ARRIVE_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-08-28 13:54:51 using DbdbTap
 */
export const ArriveInfoDictionary = {
    inputMap: Dict,
    usageMap: DictUsage,
    errorTitle: {
        Add: '도착정보 등록 오류',
        Edit: '도착정보 수정 오류',
        Remove: '도착정보 삭제 오류',
        Get: '도착정보 조회 오류',
    },
    tableProps: {
        tableId: 'arriveInfoTable',
        uniqueKey: Dict.arriveId.id,
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'dcTypeName', label: Dict.dcTypeName.label, width: 90, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'arriveId', label: Dict.arriveId.label, width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'dcCd', label: Dict.dcCd.label+'코드', width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'dcName', label: Dict.dcName.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeId', label: Dict.storeId.label+'코드', width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'storeName', label: Dict.storeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'basicDockno', label: Dict.basicDockno.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'distanceOne', label: Dict.distanceOne.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'distanceRound', label: Dict.distanceRound.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'basicExpectRunTime', label: Dict.basicExpectRunTime.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'startReqTimeToday', label: Dict.startReqTimeToday.label, width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'arriveReqTimeNext', label: Dict.arriveReqTimeNext.label, width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'useYn', label: '사용여부', width: 90, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y'?'사용':'사용중지'} },
            //{ id: 'regTypeCd', label: Dict.regTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regType', label: Dict.regType.label, width: 80, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'autoPlanYn', label: Dict.autoPlanYn.label, width: 80, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y'?'사용':'-'} },
            { id: 'mainVehTypeName', label: Dict.mainVehTypeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'maxVehTypeName', label: Dict.maxVehTypeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'firstShipTime', label: Dict.firstShipTime.label, width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'lastShipTime', label: Dict.lastShipTime.label, width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'comName', label: Dict.comName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'pbsOrder', label: Dict.pbsOrder.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'loadMaxCnt', label: Dict.loadMaxCnt.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'autoPlanOrder', label: Dict.autoPlanOrder.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'autoViewOrder', label: Dict.autoViewOrder.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            // { id: 'mainVehTypeId', label: Dict.mainVehTypeId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            // { id: 'maxVehTypeId', label: Dict.maxVehTypeId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'storeApplyCom', label: Dict.storeApplyCom.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regDate', label: "등록일", width: 100, show: true, option:{align: 'center', print:(r,i,v)=>ValueMisc.substr(v,0,10)} },
            { id: 'regUserName', label: Dict.regUserName.label, width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            // { id: 'dcTypeCd', label: Dict.dcTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'storeTypeName', label: Dict.storeTypeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'storeTypeCd', label: Dict.storeTypeCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            
        ]
    },
    autoOrderTableProps: {
        ...AutoOrderTableProps,
        columns: [
            { id: 'storeId', label: Dict.storeId.label+'코드', width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'autoViewOrder', label: Dict.autoViewOrder.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'storeName', label: Dict.storeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
    uploadTableProps: {
        tableId: 'arriveInfoUploadTable',
        uniqueKey: Dict.storeId.id,
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
            noSorting: true,
            hideBubble: true,
        },
        columns: [
            { id: 'ok', label: '상태', width: 50, show: true, option:{align: 'center', print:(r,i,v)=>v?'OK':<span style={{color:'red'}}>오류</span>} },
            { id: 'dcCd', label: Dict.dcCd.label, width: 60, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'storeId', label: Dict.storeId.label, width: 80, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'basicDockno', label: Dict.basicDockno.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'distanceOne', label: Dict.distanceOne.label, width: 70, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'distanceRound', label: Dict.distanceRound.label, width: 70, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'basicExpectRunTime', label: Dict.basicExpectRunTime.label, width: 110, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'startReqTimeToday', label: Dict.startReqTimeToday.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'arriveReqTimeNext', label: Dict.arriveReqTimeNext.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
        ]
    },
    // 동적점포 후보용 테이블
    storesSharingRouteTableProps: {
        tableId: 'arriveInfoStoresSharingRouteTable',
        uniqueKey: Dict.storeId.id,
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
            hideBubble: true,
        },
        columns: [
            { id: 'storeId', label: '점포코드', width: 70, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'storeName', label: '점포명', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'maxVehTypeName', label: Dict.maxVehTypeName.label, width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'firstShipTime', label: Dict.firstShipTime.label, width: 90, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'addr', label: '주소', width: 150, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
    // DIDA 설정용 점포 목록 테이블
    storesForDidaTableProps: {
        tableId: 'arriveInfoStoresForDidaTable',
        uniqueKey: Dict.storeId.id,
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
            hideBubble: true,
        },
        columns: [
            { id: 'storeId', label: '점포코드', width: 70, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'storeName', label: '점포명', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'addr', label: '주소', width: 230, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
};

